import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  firstname: string = '';
  lastname: string = '';
  email: string = '';
  userpassword: string = '';
  code: string = '';
  isSubmitting: boolean = false;

  constructor() { }

  registro() {
    if (this.isSubmitting || this.validarNoDatos()) return;
    
    this.isSubmitting = true;
    
    // Simular registro exitoso
    console.log('Registro exitoso:', {
      username: this.email,
      password: this.userpassword,
      attributes: {
        email: this.email,
        "custom:firstname": this.firstname,
        "custom:lastname": this.lastname
      }
    });
    
    // Simular delay de petición
    setTimeout(() => {
      alert('Registro exitoso! Hemos enviado un link de activación a tu correo electrónico.');
      this.isSubmitting = false;
    }, 1000);
  }

  validarNoDatos() { 
    if (!this.firstname) return true;
    if (!this.lastname) return true;
    if (!this.email) return true;
    if (!this.userpassword) return true;
    return false;
  }

  ngOnInit() {
    document.body.classList.add('bg-account-pages');
    document.body.classList.add('py-4');
    document.body.classList.add('py-sm-0');
  }
}
